import { createAction } from 'redux-act';

export type ActivePaymentFormPayload = Record<string, unknown> | null;

export const setActivePaymentModalVisible = createAction<boolean>(
  'SET_ACTIVE_PAYMENT_MODAL_VISIBLE'
);
export const setActivePaymentForm =
  createAction<ActivePaymentFormPayload>('SET_ACTIVE_PAYMENT_FORM');
export const closeActivePaymentForm = createAction('CLOSE_ACTIVE_PAYMENT_FORM');
